import { FB_APP_ID } from '@constants'

const loadFacebookSDK = (): Promise<fb.FacebookStatic> => {
  const id = 'facebook-jssdk'

  return new Promise(resolve => {
    if (document.getElementById(id)) {
      return resolve(window.FB)
    }

    window.fbAsyncInit = () => {
      window.FB.init({
        appId: FB_APP_ID,
        autoLogAppEvents: false,
        xfbml: false,
        version: 'v7.0',
      })
      resolve(window.FB)
    }

    const fjs = document.getElementsByTagName('script')[0]
    const js = document.createElement('script')
    js.id = id
    js.src = 'https://connect.facebook.net/en_US/sdk.js'
    fjs.parentNode?.insertBefore(js, fjs)

    return Promise.resolve()
  })
}

export default loadFacebookSDK
